$('#owl-example').owlCarousel({
    items: 4,
    autoPlay: true,
    stopOnHover: true,
})
